// context/BreadcrumbContext.js
import React, { createContext, useContext, useState, useCallback } from "react";

const BreadcrumbContext = createContext();

export const BreadcrumbProvider = ({ children }) => {
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  const addBreadcrumb = useCallback((item) => {
    setBreadcrumbs((prev) => {
      if (prev.find((b) => b.to === item.to)) return prev; // avoid duplicates
      return [...prev, item];
    });
  }, []);

  const removeBreadcrumb = useCallback((path) => {
    setBreadcrumbs((prev) => prev.filter((b) => b.to !== path));
  }, []);

  const clearBreadcrumbs = useCallback(() => setBreadcrumbs([]), []);

  return (
    <BreadcrumbContext.Provider
      value={{ breadcrumbs, addBreadcrumb, removeBreadcrumb, clearBreadcrumbs }}
    >
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumb = () => useContext(BreadcrumbContext);
